export default {
    "defaultGameSlug": "teach"
}
